import { shadow } from 'styled-system';
import { AnyStringLiteral } from '@tanium/coreui-utils';
import { ShadowsValue } from '@tanium/theme-data';
import { CoreUiStyleType } from './types';

export interface ShadowStyleProps {
  boxShadow?: CoreUiStyleType<ShadowsValue | AnyStringLiteral>;
  textShadow?: CoreUiStyleType<ShadowsValue | AnyStringLiteral>;
}

export const shadowStylePropNames: (keyof ShadowStyleProps)[] = ['boxShadow', 'textShadow'];

export { shadow };
